import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkHOD, checkHOU } from '../../permission-utils/settings';

const AccountingMenu = () => {
	const [isSupervisor, setIsSuperVisor] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{isSupervisor && (
				<li>
					<Link to="/paypoint/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/accounting/payroll">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Payroll</span>
				</Link>
			</li>
			<li>
				<Link to="/accounting/config">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Payroll Settings</span>
				</Link>
			</li>
			<li>
				<Link to="/accounting/transactions">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Transactions</span>
				</Link>
			</li>
			<li>
				<Link to="/accounting/discharge-queue">
					<div className="icon-w">
						<div className="icon-feather-log-out" />
					</div>
					<span>Discharge Queue</span>
				</Link>
			</li>
			<li>
				<Link to="/nicu">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-03" />
					</div>
					<span>NICU</span>
				</Link>
			</li>
			<li>
				<Link to="/accounting/encounter-sheet">
					<div className="icon-w">
						<div className="os-icon os-icon-file-text" />
					</div>
					<span>Encounter Sheet</span>
				</Link>
			</li>{' '}
		</>
	);
};

export default AccountingMenu;
